(function () {
  'use strict';

  var config = {
    giftVariantId: 48351992184985,
    thresholdCents: 17500,
    giftPropertyName: '_auto_gwp',
    giftPropertyValue: 'free-coloring-book-175',
    pollDelayMs: 450
  };

  var inFlight = false;
  var queued = false;
  var timer = null;

  function isCartMutationUrl(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js|\?|$)/.test(url);
  }

  function lineHasAutoProperty(line) {
    return line && line.properties && line.properties[config.giftPropertyName] === config.giftPropertyValue;
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: config.giftVariantId,
        quantity: 1,
        properties: {
          _auto_gwp: config.giftPropertyValue,
          _gift_label: 'Free gift with $175+ purchase'
        }
      })
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: line.key,
        quantity: quantity
      })
    });
  }

  function refreshCartUi() {
    if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'arpi-gwp-auto-add' });
    }

    document.dispatchEvent(new CustomEvent('arpi:gwp:updated'));

    if (/^\/cart(?:\?|$)/.test(window.location.pathname + window.location.search)) {
      window.location.reload();
    }
  }

  function syncGift() {
    if (inFlight) {
      queued = true;
      return Promise.resolve();
    }

    inFlight = true;
    queued = false;

    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var giftLines = items.filter(function (line) {
          return Number(line.variant_id) === config.giftVariantId;
        });
        var autoGiftLine = giftLines.find(lineHasAutoProperty);
        var hasAnyGift = giftLines.length > 0;
        var qualifyingSubtotal = items.reduce(function (sum, line) {
          if (Number(line.variant_id) === config.giftVariantId) return sum;
          return sum + Number(line.original_line_price || line.line_price || 0);
        }, 0);
        var qualifies = qualifyingSubtotal >= config.thresholdCents;

        if (qualifies && !hasAnyGift) {
          return addGift().then(refreshCartUi);
        }

        if (qualifies && autoGiftLine && Number(autoGiftLine.quantity) !== 1) {
          return changeLine(autoGiftLine, 1).then(refreshCartUi);
        }

        if (!qualifies && autoGiftLine) {
          return changeLine(autoGiftLine, 0).then(refreshCartUi);
        }

        return null;
      })
      .catch(function (error) {
        window.console && window.console.warn && window.console.warn('[Arpi GWP]', error);
      })
      .finally(function () {
        inFlight = false;
        if (queued) scheduleSync();
      });
  }

  function scheduleSync() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncGift, config.pollDelayMs);
  }

  function watchFetch() {
    if (!window.fetch || window.fetch.__arpiGwpWatched) return;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : request && request.url;

      var options = arguments[1] || {};
      var method = String(options.method || (request && request.method) || 'GET').toUpperCase();

      return originalFetch.apply(this, arguments).then(function (response) {
        if (method !== 'GET' && isCartMutationUrl(url)) scheduleSync();
        return response;
      });
    };
    window.fetch.__arpiGwpWatched = true;
  }

  function watchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__arpiGwpWatched) return;

    var open = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__arpiGwpMethod = String(method || 'GET').toUpperCase();
      this.__arpiGwpUrl = url;
      return open.apply(this, arguments);
    };

    var send = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function () {
      if (this.__arpiGwpMethod !== 'GET' && isCartMutationUrl(this.__arpiGwpUrl)) {
        this.addEventListener('loadend', scheduleSync);
      }
      return send.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.__arpiGwpWatched = true;
  }

  watchFetch();
  watchXhr();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  window.addEventListener('pageshow', scheduleSync);
})();
